import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/*
  Workshop product blocks (status line, facts row, details table) are plain Liquid, so unlike
  Horizon's own blocks they did not refresh when a colour or size was picked. 15 Oct: the status
  has to change between In stock and Available to order in per size, so swap them from the
  section HTML Horizon already fetches for the new variant.
*/
const SELECTORS = ['.ccw-status-row', '.ccw-facts', '.ccw-docket'];

function refresh(section, html) {
  for (const selector of SELECTORS) {
    const current = section.querySelectorAll(selector);
    const next = html.querySelectorAll(selector);
    current.forEach((el, i) => next[i] && morph(el, next[i]));
  }
}

for (const section of document.querySelectorAll('.shopify-section')) {
  if (section.dataset.ccwProduct || !section.querySelector('.ccw-status-row, .ccw-facts')) continue;
  section.dataset.ccwProduct = 'true';
  section.addEventListener(StandardEvents.productSelect, (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => detail?.html && refresh(section, detail.html))
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ccw-product]', error);
      });
  });
}
